import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { API_BASE_URL } from '../constants';
import { useToast } from '../hooks/useToast';

interface ContactProps {
}

const Contact: React.FC<ContactProps> = () => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/send-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, email, message, recipient: 'admin@adservo.net' }),
      });

      if (response.ok) {
        useToast('Your message has been sent successfully!', 'success');
        setName('');
        setEmail('');
        setMessage('');
      } else {
        useToast('Failed to send message. Please try again later.', 'error');
      }
    } catch (error) {
      console.error('Error sending contact form:', error);
      useToast('Failed to send message. Please check your internet connection and try again.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-brand-background dark:bg-slate-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-brand-dark dark:text-white">{t('contact_title')}</h2>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-slate-600 dark:text-slate-300">
            {t('contact_subtitle')}
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-white dark:bg-slate-800 p-8 sm:p-12 rounded-xl border border-slate-200 dark:border-slate-700">
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-slate-700 dark:text-slate-300">{t('form_name')}</label>
              <input type="text" id="name" name="name" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1 block w-full border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-700 rounded-md shadow-sm focus:ring-brand-green focus:border-brand-green" />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-slate-700 dark:text-slate-300">{t('form_email')}</label>
              <input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 block w-full border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-700 rounded-md shadow-sm focus:ring-brand-green focus:border-brand-green" />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="message" className="block text-sm font-medium text-slate-700 dark:text-slate-300">{t('form_message')}</label>
              <textarea id="message" name="message" rows={4} value={message} onChange={(e) => setMessage(e.target.value)} required className="mt-1 block w-full border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-700 rounded-md shadow-sm focus:ring-brand-green focus:border-brand-green"></textarea>
            </div>
            <div className="md:col-span-2 text-right">
              <button 
                type="submit" 
                className="bg-brand-green text-white font-bold py-3 px-8 rounded-lg shadow-md hover:bg-opacity-90 transition-colors duration-300 disabled:opacity-70 disabled:cursor-not-allowed"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : t('send_message_btn')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;